import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import {
  productCategoryFilterOptions,
  productStatusFilterOptions,
} from '@/config/productRegistry';

interface ProductFiltersProps {
  status: string;
  category: string;
  onStatusChange: (value: string) => void;
  onCategoryChange: (value: string) => void;
}

export function ProductFilters({
  status,
  category,
  onStatusChange,
  onCategoryChange,
}: ProductFiltersProps) {
  const { t } = useTranslation('entity-portal');

  return (
    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5}>
      <FormControl size="small" sx={{ minWidth: 160 }}>
        <InputLabel id="product-status-filter-label">
          {t('productRegistry.productRegistryStatusFilterLabel')}
        </InputLabel>
        <Select
          labelId="product-status-filter-label"
          value={status}
          label={t('productRegistry.productRegistryStatusFilterLabel')}
          onChange={(event) => onStatusChange(event.target.value)}
        >
          {productStatusFilterOptions.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {t(option.labelKey)}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl size="small" sx={{ minWidth: 160 }}>
        <InputLabel id="product-category-filter-label">
          {t('productRegistry.productRegistryCategoryFilterLabel')}
        </InputLabel>
        <Select
          labelId="product-category-filter-label"
          value={category}
          label={t('productRegistry.productRegistryCategoryFilterLabel')}
          onChange={(event) => onCategoryChange(event.target.value)}
        >
          {productCategoryFilterOptions.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {t(option.labelKey)}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Stack>
  );
}
